/**
 * Dev-sync J1 — the chart legend (#psy-legend).
 *
 * Port of legacy renderLegend (psychrometric_chart.js:1033-1068). Two
 * columns: left is what a marker's COLOR means (season / missing data /
 * annotation), right is what a line's STYLE means (air stream) — independent
 * encodings, laid out side by side. All class names verbatim; the 114 psy-
 * rules already merged into common.css style this for free (survey §C2).
 *
 * Legacy fills the template's empty #psy-legend div only from renderChart
 * (data present) — with no data this renders the same empty div.
 */

import type { PsyChartData, PsySeasonFilter } from './psychrometricApi';
import { hasMissing } from './chartTraces';

interface LegendProps {
  data: PsyChartData | null;
  season: PsySeasonFilter;
}

const Legend = ({ data, season }: LegendProps) => {
  if (!data) return <div id="psy-legend" />;

  const seasons = season !== 'both' ? [season] : (['summer', 'winter'] as const);

  return (
    <div id="psy-legend">
      <div className="psy-legend-columns">
        <div className="psy-legend-col">
          {seasons.map((seasonKey) => (
            <div className="psy-legend-row" key={seasonKey}>
              <span
                className={`psy-swatch ${
                  seasonKey === 'winter' ? 'psy-swatch-winter' : 'psy-swatch-summer'
                }`}
              />{' '}
              {seasonKey.charAt(0).toUpperCase() + seasonKey.slice(1)}
            </div>
          ))}
          {/* Gated on a gray/open marker actually being drawn — a clamped
              ENTERING point — not the broader "not fully rated" (js:1070-1078). */}
          {hasMissing(data) && (
            <div className="psy-legend-row">
              <span className="psy-swatch psy-swatch-missing" /> Data not rated
            </div>
          )}
          <div className="psy-legend-row">
            <span className="psy-swatch psy-swatch-annotation" /> User annotation
          </div>
        </div>
        <div className="psy-legend-col">
          <div className="psy-legend-row">
            <span className="psy-line-swatch psy-line-solid" /> Supply
          </div>
          <div className="psy-legend-row">
            <span className="psy-line-swatch psy-line-dotted" /> Return
          </div>
          <div className="psy-legend-row">
            <span className="psy-line-swatch psy-line-dashed" /> Exhaust
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legend;
